import { render, staticRenderFns } from "./AochenHead.vue?vue&type=template&id=1f801eda&scoped=true"
import script from "./AochenHead.vue?vue&type=script&lang=js"
export * from "./AochenHead.vue?vue&type=script&lang=js"
import style0 from "./AochenHead.vue?vue&type=style&index=0&id=1f801eda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f801eda",
  null
  
)

export default component.exports